












































































































































































































































































































































import { Vue, Component, Watch } from "vue-property-decorator";
import { EventBus } from "@/events/index";
import { StoreModule } from "@/store/types";
import { RepGetters } from "@/store/modules/rep/types";
import { namespace } from "vuex-class";
import { CustomerGetters } from "@/store/modules/customer/types";
import { ExportGetters } from "@/store/modules/export/types";
import { GlobalGetters } from "@/store/modules/global/types";
import { CustomerSchema } from "@/models/customer_schema";
import { CustomerStatus, CustomerType } from "@/models/customer";
import { Roles } from "@/models/roles";
import { Layers } from "@/models/map/layers";
import moment from "moment";
import UIkit from "uikit";
import { UserGetters } from "@/store/modules/user/types";
import { ExportFilters } from "@/models/export/filters";
import SalesRegionMap from "@/models/map/region";
import CustomerService from "@/services/customer_service";
import { User } from "@/models/user_schema";
import Loading from "vue-loading-overlay";
import { SalesContactSchema } from "@/models/sales_contact_schema";
import simplebar from "simplebar-vue";

const sortValueOptions = [
  "customer_name",
  "full_name",
  "address_1",
  "city",
  "state",
  "postal_code",
  "country",
  "phone",
  "website_url",
  "sales_region",
  "status",
  "email",
] as const;

@Component({
  components: {
    Loading,
    simplebar,
  },
})
export default class Export extends Vue {
  protected spinner = false;
  protected exportDataAll: any[] = [];
  protected exportDataSelected: any[] = [];
  protected customerService = new CustomerService();
  protected Roles = Roles;
  protected Layers = Layers;
  protected CustomerStatus = CustomerStatus;
  protected CustomerType = CustomerType;
  protected includeContacts = false;
  protected contactsData: SalesContactSchema[][] = []; // NOTE: this is an array of arrays, not objects
  protected dataWithContacts: CustomerSchema[] = [];
  protected filters: {
    data: ExportFilters["data"];
    region: ExportFilters["region"][];
    customer_type: ExportFilters["customer_type"][];
    status: ExportFilters["status"][];
    layer: ExportFilters["layer"];
  } = {
    data: "customer",
    region: [],
    customer_type: [],
    status: [],
    layer: { displayName: "Retail & Design", handle: Layers.Customers },
  };
  protected SalesRegionMap = SalesRegionMap;
  protected date = moment().format("MM-DD-YY");
  protected selected: string[] = [];
  protected sortFields = [
    "customer_name",
    "full_name",
    "address_1",
    "city",
    "state",
    "postal_code",
    "country",
    "phone",
    "website_url",
    "sales_region",
    "status",
    "email",
  ];
  protected repExportFields = [
    "_id",
    "phone",
    "email",
    "website_url",
    "status",
    "type",
    "address_1",
    "address_2",
    "city",
    "state",
    "postal_code",
    "country",
    "address",
    "customer_name",
    "full_name",
  ];
  protected labels = {
    customer_name: "Customer Name",
    store_name: "Store Name",
    address_1: "Address",
    address_2: "Address 2",
    city: "City",
    state: "State",
    postal_code: "Postal Code",
    country: "Country",
    phone: "Phone Number",
    email: "Email Address",
    website_url: "Website URL",
    first_name: "Contact First Name",
    last_name: "Contact Last Name",
    status: "Status",
    customer_since: "Customer Since",
    sales_region: "Sales Region",
    multiplier: "Multiplier",
    0: "Longitude",
    1: "Latitude",
    created_at: "Created Date",
    updated_at: "Last Updated Date",
    hide_from_map: "Hide from Retail Locator",
    industry_only: "Industry Only",
    trade_only: "Trade Only",
    _id: "Database ID",
    customer_type: "Customer Type",
  };
  protected fields = [
    "customer_name",
    "store_name",
    "address_1",
    "address_2",
    "city",
    "state",
    "postal_code",
    "country",
    "phone",
    "email",
    "website_url",
    "first_name",
    "last_name",
    "status",
    "customer_since",
    "sales_region",
    "multiplier",
    0,
    1,
    "created_at",
    "updated_at",
    "hide_from_map",
    "industry_only",
    "trade_only",
    "_id",
    "customer_type",
  ];
  protected sort: {
    value: typeof sortValueOptions[number];
    order: "asc" | "desc";
  } = { value: "customer_name", order: "asc" };
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetActiveView))
  activeView;
  @(namespace(StoreModule.Customer).Getter(CustomerGetters.GetAllCustomers))
  customers;
  @(namespace(StoreModule.Rep).Getter(RepGetters.GetAllReps)) reps;
  @(namespace(StoreModule.Export).Getter(ExportGetters.GetExportFilters))
  exportFilters;
  @(namespace(StoreModule.User).Getter(UserGetters.GetRole)) role;
  @(namespace(StoreModule.User).Getter(UserGetters.GetSalesRegion))
  repSalesRegion;

  /**
   * Watch selected property - filters data to use only selected rows
   */
  @Watch("selected")
  protected onChange() {
    if (this.selected.length > 0) {
      this.exportDataSelected = this.exportDataAll.filter((row) => {
        let match;
        this.selected.forEach((id) => {
          if (id == row._id) {
            match = true;
          }
        });
        if (match) {
          return row;
        }
      });
    }
  }

  /**
   * Returns appropriate data for export
   * (Parsing one singular property upon export is buggy)
   */
  protected get forExport(): any[] {
    return this.selected.length > 0
      ? this.exportDataSelected
      : this.exportDataAll;
  }

  public created() {
    EventBus.$emit("getExportData");
    this.getSalesContactInfo();
  }

  public mounted() {
    this.$nextTick(() => this.createFilters());
  }

  /**
   * Logic to preselect filters on initial mounting of component
   */
  public createFilters(): void {
    if (this.role === Roles.SalesRep || !this.filters.layer) {
      this.filters.layer.handle === Layers.Customers;
    }
    if (
      this.exportFilters.region &&
      this.filters.layer.handle === Layers.Customers
    ) {
      // if false, "all" regions should be checked
      this.filters.region.push(this.exportFilters.region);
    } else if (this.filters.layer.handle === Layers.Customers) {
      this.checkAllBoxesInputs("region", true);
    }
    if (
      this.exportFilters.customer_type &&
      this.filters.layer.handle === Layers.Customers
    ) {
      this.filters.customer_type.push(this.exportFilters.customer_type);
    } else if (this.filters.layer.handle === Layers.Customers) {
      this.checkAllBoxesInputs("customer_type", true);
    }
    if (this.exportFilters.status) {
      this.filters.status.push(this.exportFilters.status);
    } else {
      this.checkAllBoxesInputs("status", true);
    }
    this.filters.data = this.exportFilters.data;
    this.filters.layer = this.exportFilters.layer;
  }

  get customerTypeOptions(): CustomerType[] {
    return [this.CustomerType.Customer, this.CustomerType.Designer];
  }

  /**
   * Transforming the format of the data that holds which type of customer we're viewing, so the select element can have a user friendly display name
   */
  get customerTypeList(): object[] {
    const values = [
      { handle: Layers.Customers, displayName: "Retail & Design" },
      { handle: Layers.Contract, displayName: "Contract Dealers" },
      { handle: Layers.Beach, displayName: "Beach Concessionaires" },
    ];
    return values;
  }

  /**
   * "New" is based on a calculation, so it needs to be manually added to the options in addition to those in the enum
   */
  get customerStatusOptions(): any[] {
    const options = ["new"];
    for (const value in this.CustomerStatus) {
      options.push(this.CustomerStatus[value]);
    }
    return options;
  }

  get regionList(): string[] {
    const values: string[] = [];
    if (this.role === Roles.SalesRep) {
      values.push(this.repSalesRegion);
    } else {
      for (const [key, value] of this.SalesRegionMap.entries()) {
        values.push(value);
      }
    }
    return values;
  }

  /**
   * This computer getter handles all filtering
   */
  get filteredCustomers(): CustomerSchema[] {
    this.selected = [];
    let regionArray = this.customers;
    if (this.includeContacts) {
      regionArray = [...this.dataWithContacts];
    }

    // layer/customer type filtering
    if (
      this.role !== Roles.SalesRep &&
      this.filters.layer &&
      this.filters.layer.handle === Layers.Contract
    ) {
      regionArray = regionArray.filter((customer) => {
        return customer.customer_type === CustomerType.Contract;
      });
    } else if (
      this.role !== Roles.SalesRep &&
      this.filters.layer &&
      this.filters.layer.handle === Layers.Beach
    ) {
      regionArray = regionArray.filter((customer) => {
        return customer.customer_type === CustomerType.BeachConcession;
      });
    } else {
      regionArray = regionArray.filter((customer) => {
        return (
          customer.customer_type === CustomerType.Customer ||
          customer.customer_type === CustomerType.Designer
        );
      });
    }

    // region filtering. only available for retail & design customers
    if (
      this.role !== Roles.SalesRep &&
      this.filters.layer.handle === Layers.Customers
    ) {
      regionArray = regionArray.filter((customer) => {
        return (
          this.filters.region.includes(customer.sales_region) &&
          (customer.customer_type === CustomerType.Customer ||
            customer.customer_type === CustomerType.Designer)
        );
      });
      regionArray = regionArray.filter((customer) => {
        return this.filters.customer_type.includes(customer.customer_type);
      });
    }

    if (
      this.filters.status.length === 1 &&
      this.filters.status.includes("new")
    ) {
      // a customer is "new"  if it is marked current & was customer since at less than or equal to a year from this date
      regionArray = regionArray.filter((customer) => {
        return (
          customer.customer_since &&
          customer.status === CustomerStatus.Current &&
          moment().diff(moment(customer.customer_since), "years", true) <= 1
        );
      });
    } else {
      regionArray = regionArray.filter((customer) => {
        return this.filters.status.includes(customer.status);
      });
    }
    // sorting logic for columns that are displaying nested address values
    if (
      this.sort.value === "address_1" ||
      this.sort.value === "city" ||
      this.sort.value === "state" ||
      this.sort.value === "postal_code" ||
      this.sort.value === "country"
    ) {
      if (this.sort.order === "asc") {
        regionArray.sort((first, second) => {
          if (first.address[this.sort.value] < second.address[this.sort.value])
            return -1;
          if (first.address[this.sort.value] > second.address[this.sort.value])
            return 1;
        });
      }
      if (this.sort.order === "desc") {
        regionArray.sort((first, second) => {
          if (first.address[this.sort.value] < second.address[this.sort.value])
            return 1;
          if (first.address[this.sort.value] > second.address[this.sort.value])
            return -1;
        });
      }
    } else {
      //sorting for all other columns
      if (this.sort.order === "asc") {
        regionArray.sort((first, second) => {
          if (first[this.sort.value] < second[this.sort.value]) return -1;
          if (first[this.sort.value] > second[this.sort.value]) return 1;
        });
      }
      if (this.sort.order === "desc") {
        regionArray.sort((first, second) => {
          if (first[this.sort.value] < second[this.sort.value]) return 1;
          if (first[this.sort.value] > second[this.sort.value]) return -1;
        });
      }
    }
    this.exportDataAll = regionArray.map((row) => {
      delete row.address._id;
      return this.flattenObject(row);
    }); // saving filtered data as a flattened object in the export property.
    return regionArray;
  }

  /**
   * On component creation, fetch sales contact info for every customer and store in component property
   */
  protected async getSalesContactInfo(): Promise<void> {
    this.spinner = true;
    for (const c of this.customers) {
      this.dataWithContacts.push(c);
      if (c.sales_contacts && c.sales_contacts.length > 0) {
        for (const [index, contact] of c.sales_contacts.entries()) {
          const contactRow = this.createContactRow(c, contact, index);
          this.dataWithContacts.push(contactRow);
        }
      }
    }
    this.spinner = false;
  }

  /**
   * Taking sales contact data and adding matching customer information to the object
   */
  public createContactRow(customer, contact, index) {
    const newRow = { ...customer };
    newRow.full_name = contact.first_name + " " + contact.last_name;
    newRow.email = contact.email;
    newRow._id = "c" + contact.customer + "_" + index;
    return newRow;
  }

  public makeSentenceCase(option: string) {
    return option.charAt(0).toUpperCase() + option.slice(1);
  }

  public makeTitleCase(option: string) {
    return option
      .toLowerCase()
      .split(" ")
      .map(function (word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(" ");
  }

  public selectLayer(layer: ExportFilters["layer"]) {
    UIkit.dropdown(this.$refs.layer).hide(false);
    this.filters.layer = layer;
  }

  /**
   * Setting sort properties on user selection, and toggling column arrows based on asc/desc
   */
  public selectSort(sortValue: typeof sortValueOptions[number]): void {
    if (this.sort.value !== sortValue) {
      this.sort.value = sortValue;
      this.sort.order = "asc";
      (this.$refs[sortValue + "Arrow"] as HTMLSpanElement).innerHTML =
        '<span class="icon sort-up"></span>';
      this.sortFields.forEach((field) => {
        (this.$refs[field + "Arrow"] as HTMLSpanElement).innerHTML =
          '<span class="icon sort-up"></span>';
      });
    } else {
      if (this.sort.order === "desc") {
        this.sort.order = "asc";
        (this.$refs[sortValue + "Arrow"] as HTMLSpanElement).innerHTML =
          '<span class="icon sort-up"></span>';
      } else {
        this.sort.order = "desc";
        (this.$refs[sortValue + "Arrow"] as HTMLSpanElement).innerHTML =
          '<span class="icon sort-down"></span>';
      }
    }
  }

  /**
   * Flatten a multidimensional object
   *
   * For example:
   *   flattenObject({ a: 1, b: { c: 2 } })
   * Returns:
   *   { a: 1, c: 2}
   *
   * Also filters what fields to return based on user permissions; sales reps can only see certain fields (held in this.repExportFields)
   */
  public flattenObject(tableRow: CustomerSchema | User) {
    const flattened = {} as any;
    const obj = { ...tableRow };
    if (this.role === Roles.SalesRep) {
      Object.keys(obj).forEach((key) => {
        if (!this.repExportFields.includes(key)) {
          delete obj[key];
        }
      });
    }
    Object.keys(obj).forEach((key) => {
      if (typeof obj[key] === "object" && obj[key] !== null) {
        Object.assign(flattened, this.flattenObject(obj[key]));
      } else {
        flattened[key] = obj[key];
      }
    });
    return flattened;
  }

  /**
   * Method that checks/unchecks all checkboxes if master checkbox $ref.inputAll is changed
   * All inputs are assigned same ref so $ref.input is an array
   * Iterate over array to check boxes on/off
   */
  public checkAllBoxesRows() {
    if ((this.$refs.inputAll as HTMLInputElement).checked) {
      (this.$refs.input as HTMLInputElement[]).forEach((input) => {
        if (!input.checked) {
          input.checked = true;
          this.selected.push(input.value);
        }
      });
    } else {
      this.resetAllCheckboxRowData();
      (this.$refs.input as HTMLInputElement[]).forEach((input) => {
        input.checked = false;
      });
    }
  }

  /**
   * Method that checks/unchecks all checkboxes in the filter dropdowns
   * Automatically checked on component created or when master checkbox ($ref.[filterName]InputAll ex: $ref.regionInputAll) in each dropdown is changed
   *  All inputs are assigned same ref so $ref.[filterName]input is an array
   * Iterate over array to check boxes on/off
   * @param preselect boolean tells method whether these values are being preselected on component mount (vs. user interaction)
   */
  public checkAllBoxesInputs(
    filterName: "region" | "status" | "customer_type",
    preselect = false
  ) {
    const parentElement = filterName + "InputAll";
    const childElement = filterName + "Input";
    if ((this.$refs[parentElement] as HTMLInputElement).checked || preselect) {
      (this.$refs[parentElement] as HTMLInputElement).checked = true;
      (this.$refs[childElement] as HTMLInputElement[]).forEach((input) => {
        if (!input.checked) {
          input.checked = true;
          input.disabled = true;
          this.filters[filterName].push(input.value as any);
        }
      });
    } else {
      this.resetAllCheckboxInputData(filterName);
      (this.$refs[childElement] as HTMLInputElement[]).forEach((input) => {
        input.checked = false;
        input.disabled = false;
      });
    }
  }

  /**
   * Clears all ids from this.selected
   */
  public resetAllCheckboxRowData(): void {
    (this.$refs.inputAll as HTMLInputElement).checked = false;
    this.selected = [];
  }

  /**
   * Toggles all checkboxes off in corresponding filter dropdown
   */
  public resetAllCheckboxInputData(filterName: string): void {
    const parentElement = filterName + "InputAll";
    (this.$refs[parentElement] as HTMLInputElement).checked = false;
    this.filters[filterName] = [];
  }

  /** Export data method */
  protected goExport(): void {
    (this.$refs.export as Vue & { generate: () => {} }).generate();
  }
}
